import withWidth, {
  isWidthUp,
  WithWidthProps,
} from '@material-ui/core/withWidth';
import Typography, {
  TypographyProps,
} from '@serko/zui/es/Typography/Typography';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';

type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface OwnProps extends TypographyProps {
  variantXs?: TypographyProps['variant'];
  variantSm?: TypographyProps['variant'];
  variantMd?: TypographyProps['variant'];
  variantLg?: TypographyProps['variant'];
  variantXl?: TypographyProps['variant'];
}

interface ResponsiveTypographyProps extends OwnProps, WithWidthProps {}

const ResponsiveTypographyBase: FunctionComponent<
  ResponsiveTypographyProps
> = ({
  variant: variantProp,
  variantXs,
  variantSm,
  variantMd,
  variantLg,
  variantXl,
  width,
  ...props
}) => {
  const variantSizes: Record<Size, TypographyProps['variant']> = {
    xs: variantXs,
    sm: variantSm,
    md: variantMd,
    lg: variantLg,
    xl: variantXl,
  };
  const responsive = (): TypographyProps['variant'] => {
    const size = (['xl', 'lg', 'md', 'sm', 'xs'] as Size[]).find(breakpoint => {
      return isWidthUp(breakpoint, width, true) && !!variantSizes[breakpoint];
    });

    if (!size) return variantProp || undefined;

    return variantSizes[size];
  };

  return <Typography variant={responsive()} {...props} />;
};

const enhance = compose<ResponsiveTypographyProps, OwnProps>(
  pure,
  withWidth(),
);

/**
 * Extension for Typography component which allows for switching `variant` prop based on breakpoint
 */
export const ResponsiveTypography = enhance(ResponsiveTypographyBase);

ResponsiveTypography.displayName = 'ResponsiveTypography';
